import React, { Component } from "react"
import Chart from "react-apexcharts"
import colorArray from "helpers/colorArray"


class GroupedBar extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		try {
			let options = {
				chart: {
					type: "bar",

					toolbar: {
						export: {
							csv: {
								columnDelimiter: ",",
							},
						},
					},
					//height: 350,
					//stacked: true,
				},
				stroke: {
					width: 1,
					colors: ["#fff"],
				},
				xaxis: {
					categories: this.props.categories,
				},
				colors: ["#3194EC", "#76B8F0"],
				fill: {
					opacity: 1,
				},
				legend: {
					position: "top",
					horizontalAlign: "left",
					offsetX: 40,
				},
				dataLabels: {
					enabled: true,
					style: {
						fontWeight: "normal",
						colors: ["#000"],
					},
				},
			}
			if (this.props.options) {
				// Override default options
				options = { ...options, ...this.props.options }
			}
			if (this.props.colorful) {
				options.colors = colorArray
			}
			//console.log(options)
			return <Chart options={options} series={this.props.series} type="bar" />
		} catch (e) {
			console.log(e)
			return ''
		}
		
	}
}

export default GroupedBar
